class KoreanCurrencyCustom extends HTMLElement {
  constructor() {
    super();
    this.needDivide = this.getAttribute("data-divide");
    this.currency = Shopify.currency.active;
    this.price = this.getAttribute("data-price");

    if (this.currency === "KRW") {
      this.formatCurrency();
    }
  }

  formatCurrency() {
    // Remove any currency symbols and convert to number
    let cleanPrice = this.price.toString().replace(/[^0-9.-]/g, "");
    let floatPrice = parseFloat(cleanPrice)

    if (this.needDivide === null) {
      floatPrice = floatPrice / 100;
    }

    if (isNaN(floatPrice)) {
      return;
    }

    // Format with Korean locale
    this.price = new Intl.NumberFormat("ko-KR").format(floatPrice) + " 원";
    this.innerHTML = this.price;
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    customElements.define("korean-currency-custom", KoreanCurrencyCustom);
  });
} else {
  customElements.define("korean-currency-custom", KoreanCurrencyCustom);
}
